<template>
  <span>{{ getDateMonth(text) }}</span>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { getDateMonth } from '@/utils/function';
export default defineComponent({
  name: 'Cell_date_month',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: true,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
  setup() {
    return {
      getDateMonth,
    };
  },
});
</script>
